import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import Api from '../../Api';
import InputField from '../../components/FieldComponents/InputField';

import './style.less';
// TODO generic message?
const PROMO_CODE_GENERIC_FAILURE_MESSAGE = 'Something went wrong applying this code. Try again in a bit';

export default class PromoCode extends React.Component {
  constructor(props) {
    super(props);

    this.onApply = this.onApply.bind(this);
    this.onShow = this.onShow.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.state = {
      show: false,
      applied: false,
      disabled: true,
      error: false,
      input: ''
    };
  }

  static propTypes = {
    className: PropTypes.string,
    onDiscount: PropTypes.func.isRequired
  };

  onApply() {
    if (this.state.disabled || !this.state.input || this.state.input.trim().length === 0) return;

    let promoCode = this.state.input.trim().toUpperCase();
    Api.validatePromoCodes([promoCode])
      .then(response => {
        let discount = response.discounts && response.discounts[promoCode]
          ? response.discounts[promoCode]
          : null;

        if (discount) {
          discount.code = promoCode;
          discount.total_amount_cents = response.total_amount_cents;
          this.setState({
            applied: discount
          });

          this.props.onDiscount(discount);
        } else {
          let error = response.errors[promoCode];
          if (!error) {
            error = PROMO_CODE_GENERIC_FAILURE_MESSAGE;
          }

          this.setState({
            error
          });
        }
      })
      .catch(error => {
        error = error.message || JSON.stringify(error);
        this.setState({
          error
        });
      });
  }

  onShow() {
    let show = !this.state.show;
    let input = show ? '' : this.state.input;

    this.setState({
      show,
      error: false,
      input
    });
  }

  onInput(_, value) {
    this.setState({
      input: value,
      error: false,
      disabled: value.trim().length === 0
    });
  }

  onKeyDown(event) {
    if (!this.state.show) {
      event.preventDefault();
      return;
    }
    let keyCode = event.keyCode || event.key;

    // Return = 13
    if (keyCode === 13 && !this.state.error && this.state.show) {
      event.preventDefault();
      this.onApply();
    }

    // Escape = 27
    if (keyCode === 27) {
      event.preventDefault();
      this.onShow();
    }
  }

  render() {
    let componentClassNames = ['promo-code-component'];
    if (this.state.show) componentClassNames.push('show');
    let applyOrInvalidView = null;

    if (this.state.error) {
      componentClassNames.push('invalid');
      applyOrInvalidView = <div className="invalid-message">{this.state.error}</div>;
    } else {
      applyOrInvalidView =
        <div onClick={this.onApply}
             className={`apply-button ${this.state.disabled ? 'disabled' : ''}`}>
          Apply
        </div>;
    }

    let view = null;
    if (this.state.applied) {
      let discountMessage = this.state.applied.message
        ? <div>{this.state.applied.message}</div>
        : null;
      view = <div className="applied">
        <div className="icon"/>
        <div className="messages">
          <div>{this.state.applied.code} was successfully applied to your cart!</div>
          {discountMessage}
        </div>
      </div>

    } else {
      view = <div>
        <div className="label"
             onClick={this.onShow}>
          <div className="switch"><FontAwesome name="close"/></div>
          <span>ADD A PROMO CODE</span>
        </div>
        <div className="promo-code-input">
          <InputField name="promoCodeInput"
                      value={this.state.input}
                      onInput={this.onInput}
                      className={this.props.className}
                      onKeyDown={this.onKeyDown}
          />
          {applyOrInvalidView}
        </div>
      </div>;
    }

    return (
      <div className={componentClassNames.join(' ')}>
        {view}
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/PromoCode/index.jsx
 **/